import { FormattedMessage } from "react-intl";

import { Button } from "@/ui-components/commonComponents/Button/Button";
import { AssessmentCopy } from "@/modules/candidate/assessmentCopy";

import { contentLoadErrorMessages } from "./contentLoadError.messages";
import styles from "./style.module.css";

export function ContentLocaleError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className={styles.container} role="alert">
      <p className={styles.message}>
        <AssessmentCopy variants={contentLoadErrorMessages} />
      </p>
      <Button onClick={onRetry}>
        <FormattedMessage id="candidate.languageSelect.contentLoadRetry" defaultMessage="Try again" />
      </Button>
    </div>
  );
}
